export default [
  // lms management
  {
    path: '/addlmsfiles',
    name: 'addlmsfiles',
    component: () => import('@/views/Lmsmanagement/Components/AddLmsDriveLink.vue'),
    meta: {
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'Add Lms Path',
      breadcrumb: [
        {
          text: 'Add LMS Drive Link',
          active: true,
        },
      ],
    },
  },

  {
    path: '/lmslinks',
    name: 'lmsLinks',
    component: () => import('@/views/Lmsmanagement/index.vue'),
    meta: {
      authReuire: true,
      role: ['Admin'],
      pageTitle: 'LMS Drive Links',
      breadcrumb: [
        {
          text: 'LMS Drive Links',
          active: true,
        },
      ],
    },
  },

]
